// extracted by mini-css-extract-plugin
module.exports = {"h100":"OrdersTable_h100_2sOdw","w100":"OrdersTable_w100_1596n","relative":"OrdersTable_relative_3MzUz","preloader":"OrdersTable_preloader_tTUhR"};